import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize
} from '@dboxdev/ui-components'
import SelectArrow from 'icons/select.svg'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
`

export const Title = styled.div`
  margin: 0 0 ${calculateResponsiveSize(20)} 0;
  &.error {
    color: red;
  }
  ${mediaMax('mobile')} {
    margin: 0 0 ${calculateResponsiveSize(3)} 0;
  }
`

export const Icon = styled.div`
  width: ${calculateResponsiveSize(13)};
  height: ${calculateResponsiveSize(8)};
  background-image: url(${SelectArrow});
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 100% auto;
  transition: transform 0.3s ease-in-out;
  /* .error & {
    background: #FF0C00;
  } */
`
